import { msg } from '..'

export function campoFracionadoComBarraMaxUmAntes(value: string) {
  if (value.indexOf('/') > 1) {
    return msg('maxCharBefore', value, 1, 'barra')
  }
  const partes = value.split('/')

  if (partes.length > 1) {
    const denominador = partes[1]
    if (!denominador || Number(denominador) === 0) {
      return msg('valueAfterSlash', value)
    }
    if (Number.isNaN(Number(denominador))) {
      return msg('numericValueAfterSlash', value)
    }
  }
}

export function campoFracionadoComVirgulaMaxDoisAntes(value: string) {
  if (value.indexOf(',') > 2) {
    return msg('maxCharBefore', value, 2, 'vírgula')
  } else if (value.endsWith(',')) {
    return msg('valueAfterComma', value)
  }
}
